import {IModule, SystemComponentType, ComponentModuleViewConfig} from '@gongxigames/framework/core/types';
import {injectable, inject} from '@gongxigames/framework/core/installer';
import {consoleLogger} from '@gongxigames/framework/core/fragments/ConsoleLogger';
import {SignalEventEmitterWrapper} from '@gongxigames/framework/core/services/strictEventEmitter/SignalEventEmitterWrapper';
import {strictUiEmitter, slotStore} from '@gongxigames/framework/slotV2/globals';
import {Container} from 'pixi.js';
import {toString} from '@gongxigames/framework/core/utils/componentNameToString';
import {CoreDI} from '@gongxigames/framework/core/configs';
import {UpdateManager} from '@gongxigames/framework/core/services/UpdateManager';

@injectable()
export class UIModuleV2 implements IModule {
    public readonly type: SystemComponentType = 'module';

    @inject(CoreDI.UpdateManager)
    protected _updateManager!: UpdateManager;

    private readonly abortController = new AbortController();
    protected readonly abortSignal = this.abortController.signal;

    protected readonly emitter = new SignalEventEmitterWrapper(strictUiEmitter, {signal: this.abortSignal});
    protected readonly store = slotStore;

    public container?: Container;

    public configure<C extends ComponentModuleViewConfig>(config: C): void {
        this.setupContainer(config);
        this.onConfigure(config);
    }

    public init(): void {
        this.onInit();
        this.onSetupEvents();
    }

    public restore(): void {
        this.onRestore();
    }

    public destroy(): void {
        this.abortController.abort();
        this.onDestroy();
        this.container?.destroy({children: true});
        consoleLogger.log(`Module ${this.constructor.name} destroyed`);
    }

    protected onConfigure<C extends ComponentModuleViewConfig>(config: C): void {}
    protected onInit(): void {}
    protected onSetupEvents(): void {}
    protected onRestore(): void {}
    protected onDestroy(): void {}

    protected getParentContainer(): Container {
        return this.store.stage_rootContainer_ui.value;
    }

    protected setupContainer<C extends ComponentModuleViewConfig>(config: C): void {
        if (!this.container) {
            return;
        }

        const moduleName = toString(config.NAME);
        const parent = this.getParentContainer();

        this.container.name = moduleName;
        this.container.setParent(parent);

        if (config.layer) {
            this.container.parentGroup = config.layer.group;
        }
    }
}